<template>
<div class="focus">
    <div class="main-wapper">
        <div class="logo"></div>
        <div class="focus-title"></div>
        <div class="s-title"></div>
        <div class="qrcode">
            <img src="../../assets/H5img/focusImg/focus-qrcode.png" alt="">
        </div>
        <div class="awards"></div>
    </div>
    <div class="focus-dragen"></div>
    <div class="focus-bottom-bg"></div>
</div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {
           //设置分享
        setWxShare() {
            let openId = localStorage.getItem('openId')
            let avatar = localStorage.getItem('avatar')
            let username = localStorage.getItem('username')
            // let shareUrl = `https://smalltea.xiaoxxx.cn/#/Msupport?myopenid=${openId}&myavatar=${avatar}&myname=${username}`
            let shareUrl = `https://smalltea.xiaoxxx.cn/#/Msupport?myopenid=${openId}`
            console.log(shareUrl)
            // shareUrl = "http://test.smalltea.xiaoxxx.cn/#/Msupport?myopenid=123&myavatar=888"
            // alert(shareUrl)
            // 微信分享
            window.wx.ready(() => {
                // 分享好友
                window.wx.updateAppMessageShareData({
                    title: "乘风破浪·粽享端午", // 分享标题
                    desc: "快来助力好友瓜分小罐茶3万大奖吧！", // 分享描述
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
                    success: function () {
                        console.log(url);
                        // 设置成功
                        // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享好友次数', '分享好友次数', '1', '1']);
                    }
                });
                // 分享朋友圈
                window.wx.updateTimelineShareData({
                    title: "乘风破浪·粽享端午", // 分享标题
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
                    success: function () {
                        // 设置成功
                        window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享朋友圈次数', '分享朋友圈次数', '1', '1']);
                    }
                });
                // 1.2.0 老接口
                wx.onMenuShareAppMessage({
                    title: "乘风破浪·粽享端午", // 分享标题
                    desc: "快来助力好友瓜分小罐茶3万大奖吧！", // 分享描述
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
                    success: function () {
                        // 设置成功
                        // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享好友次数', '分享好友次数', '1', '1']);
                    }
                });
                wx.onMenuShareTimeline({
                    title: "乘风破浪·粽享端午", // 分享标题
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
                    success: function () {
                        // 设置成功
                        window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享朋友圈次数', '分享朋友圈次数', '1', '1']);
                    }
                });
            });
        }
    },
    created() {
        localStorage.setItem('isFocus', 1)
        var hiddenProperty = 'hidden' in document ? 'hidden' : 'webkitHidden' in document ? 'webkitHidden' : 'mozHidden' in document ? 'mozHidden' : null;
        document.addEventListener('visibilitychange', function () {
            if (document[hiddenProperty]) {
                console.log('页面隐藏了');
                localStorage.setItem('isFocus', 1)
            } else {
                //在这里加入ajax 请求用户关注的最新数据，如果关注了就放行，没有关注继续阻止
                console.log('页面显示了');
            }
        });
    },
    mounted() {
        this.setWxShare()
    }
}
</script>

<style scoped>
.focus {
    position: relative;
    width: 100%;
    height: 100vh;
    min-height: 13rem;
    background-color: #d3f5ea;
    /* background: url('../../assets/H5img/indexImg/bg-index.jpg') no-repeat;
    background-size: cover;
    background-position: center; */
    overflow: hidden;
}

.main-wapper {
    position: absolute;
    width: 100%;
    height: 13rem;
    top: 48%;
    transform: translateY(-50%);
    z-index: 2;
}

.focus-dragen {
    position: absolute;
    top: -0.5rem;
    right: 0;
    width: 2.91rem;
    height: 3.69rem;
    background: url('../../assets/H5img/focusImg/focus-dragen.png') no-repeat;
    background-size: cover;
    background-position: right;
    z-index: 1;
}

.focus-bottom-bg {
    position: absolute;
    bottom: -1.1rem;
    right: 0;
    width: 7.5rem;
    height: 5.43rem;
    background: url('../../assets/H5img/focusImg/focus-bottom-bg.png') no-repeat;
    background-size: cover;
    background-position: right;
}

.logo {
    position: absolute;
    left: 0.6rem;
    top: 7%;
    width: 2.53rem;
    height: 0.56rem;
    background: url('../../assets/H5img/indexImg/logo.png') no-repeat;
    background-size: cover;
    background-position: center;
}

.focus-title {
    position: absolute;
    top: 17%;
    left: 50%;
    width: 5.5rem;
    height: 2.60rem;
    transform: translateX(-50%);
    background: url('../../assets/H5img/focusImg/focus-title.png') no-repeat;
    background-size: cover;
    background-position: center;
    z-index: 2;
}

.s-title {
    position: absolute;
    top: 39%;
    left: 50%;
    transform: translateX(-50%);
    width: 5.33rem;
    height: 0.71rem;
    background: url('../../assets/H5img/focusImg/focus-s-title.png') no-repeat;
    background-size: cover;
    background-position: center;
}

.qrcode {
    position: absolute;
    top: 6.1rem;
    left: 50%;
    transform: translateX(-50%);
    width: 2.6rem;
    height: 3.01rem;
    /* background: url('../../assets/H5img/focusImg/focus-qrcode.png') no-repeat;
    background-size: cover;
    background-position: center; */
}

.qrcode img {
    width: 100%;
}

.awards {
    position: absolute;
    bottom: 0.15rem;
    left: 50%;
    transform: translateX(-50%);
    width: 6.25rem;
    height: 3.73rem;
    background: url('../../assets/H5img/focusImg/focus-awards.png') no-repeat;
    background-size: cover;
    background-position: center
}
</style>
